define.alias("shared/modifiers/show-on-hover", "calendar/modifiers/show-on-hover");